import { otto, OttoNexus } from '@otto-ec/global-resources/nexus';
import './nexus-global';

export type ProductRoomFitSheetApi = OttoNexus['ft5']['core']['productRoomFitSheet'];
const productRoomFitSheet: ProductRoomFitSheetApi = otto.ft5.core.productRoomFitSheet;
export const openSheet: ProductRoomFitSheetApi['openSheet'] = productRoomFitSheet.openSheet;
